export const getAllTags = async (payload, authToken) => {
  // Visibility-> active,disabled,"all"
  const { pageNo, limit, isSorted, sortBy, searchText, visibility, tagType } =
    payload;
  const url = `${
    process.env.REACT_APP_BASE_URL
  }/getAllTags?pageNo=${pageNo}&limit=${limit}&visibility=${visibility}&tagType=${tagType}${
    searchText ? "&searchText=" + searchText : ""
  }${sortBy ? "&sortBy=" + sortBy : ""}${
    isSorted ? "&isSorted=" + isSorted : ""
  }`;

  try {
    return await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error("Coming from Tag services : getAllTags() ", error.message);
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const addOrUpdateTag = async (payload, authToken) => {
  try {
    return await fetch(`${process.env.REACT_APP_BASE_URL}/updateTag`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error("Coming from Tag services : addOrUpdateTag()", error.message);
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const updateTagsVisibility = async (payload, authToken) => {
  try {
    return await fetch(
      `${process.env.REACT_APP_BASE_URL}/updateTagsVisibility`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Tags services : updateTagsVisibility()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};
